import { ActiveOption, Status } from "../types/ExchangeInterface";

export const colors = {
  green: "#469908",
};

export const BASE_MULTIPLIER = 10 ** 18;

export const PRESALE_CONTRACT_ADDRESS =
  "0x041567b56CD7797448CEb4357d6B5C94808e487a";

export const USDT_CONTRACT_ADDRESS =
  "0x55d398326f99059fF775485246999027B3197955";

export const PRESALE_ID = BigInt(2);

export const ICONS_PATHS = {
  bnb: "/assets/images/BNB_SVG.svg",
  usdt: "/assets/images/USDT.svg",
};

export const PAYMENT_METHODS = {
  BNB: "BNB",
  USDT: "USDT",
};
export const ACTIVE_OPTIONS = {
  BUY: "BUY" as ActiveOption,
  CLAIM: "CLAIM" as ActiveOption,
};

export const ESTIMATED_TRANSACTION_FEES = 0.0008;

export const STATUS = {
  WRONG_NETWORK: "WRONG_NETWORK" as Status,
  WALLET_DISCONNECTED: "WALLET_DISCONNECTED" as Status,
  NOT_ENOUGH_FEES: "NOT_ENOUGH_FEES" as Status,
  NOT_ENOUGH_ALLOWANCE: "NOT_ENOUGH_ALLOWANCE" as Status,
  NOT_ENOUGH_BALANCE: "NOT_ENOUGH_BALANCE" as Status,
  PRESALE_ENDED: "PRESALE_ENDED" as Status,
  NOTHING_TO_CLAIM: "NOTHING_TO_CLAIM" as Status,
  VESTING_STARTED: "VESTING_STARTED" as Status,
  LOADING: "LOADING" as Status,
  NOT_ENOUGH_TOKENS: "NOT_ENOUGH_TOKENS" as Status,
  BELOW_MINIMUM: "BELOW_MINIMUM" as Status,
};

export const isMobile = window.innerWidth < 768;